var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchasedOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "31px",
    viewBox: "0 0 30 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C3ED375F-66AB-4558-BA6A-238A1C749977") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.070588 0 0 0 0 0.415686 0 0 0 0 0.541176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15.0_Template_22",
    transform: "translate(-570.000000, -253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sent",
    transform: "translate(550.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.921861,0.870966797 C24.5766592,0.333734375 23.9340135,0 23.2450224,0 L16.0436771,0 L16.0436771,7.66747461 L29.2889462,7.66747461 L24.921861,0.870966797 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.025,0 L6.75571749,0 C6.0653139,0 5.42273543,0.334339844 5.07753363,0.872783203 L0.726524664,7.66747461 L14.025,7.66747461 L14.025,0 L14.025,0 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00383408072,9.48454687 L0.00383408072,28.8637246 C0.00383408072,30.0417852 1.06903587,31 2.37780269,31 L27.6221973,31 C28.9309641,31 29.9961659,30.0417852 29.9961659,28.8637246 L29.9961659,9.48454687 L0.00383408072,9.48454687 Z M19.5817265,17.6341563 L14.3613901,22.3331387 C14.1642377,22.5106016 13.9058072,22.599666 13.6474439,22.599666 C13.3890807,22.599666 13.1306502,22.5106016 12.9341704,22.3331387 L10.4868834,20.1308066 C10.0932511,19.7764863 10.0932511,19.2010488 10.4868834,18.846123 C10.8811883,18.4911973 11.5204709,18.4911973 11.9147758,18.846123 L13.6475112,20.406416 L18.154574,16.3494727 C18.5488789,15.9945469 19.1881614,15.9945469 19.5817937,16.3494727 C19.9760987,16.7043984 19.9760987,17.2792305 19.5817265,17.6341563 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasedOrderIcon);
export default __webpack_public_path__ + "static/media/PurchasedOrderIcon.c8d998e19f1e0a3c07ca541690de0de6.svg";
export { ForwardRef as ReactComponent };